import { Topping, ToppingValue } from "~/common/props/orchestrator";
import { useLogicProductToppings } from "../../toppings.hooks";
import { ToppingsType } from "../../type";
import styles from "./toppings-skin-1.module.css";

export const ToppingsSkin1 = ({ toppings, ...props }: ToppingsType) => {
  const { t, valueDataTopping, isActive, addOrUpdate } =
  useLogicProductToppings({
    ...props,
    toppings
  });
  return (
    <div className={`${styles.toppingsSkin2}`}>
      {(toppings || []).map((topping: Topping, index: number) =>
      <div className={`${styles.toppingsSkin2Item}`} key={`topping-${index}`}>
          <div className={`${styles.toppingSkin2Header}`}>
            <h4 className={`${styles.toppingSkin2Title}`}>{topping.name}</h4>
            <span
            className={`${styles.toppingSkin2Required} ${
            valueDataTopping[(index as keyof typeof valueDataTopping)] ?
            styles.toppingRequired__complete :
            ""
            }`}>

              {t("toppings.required")}
            </span>
          </div>
          <label className={`${styles.toppingSkin2Dropdown}`}>
            <input type='checkbox' />
            <div className={`${styles.toppingSkin2DropdownField}`}>
              <div className={`topping-cloud-dropdown-input`}>
                {valueDataTopping[(index as keyof typeof valueDataTopping)] ||
              t("toppings.options")}
              </div>
            </div>
            <ul className={`${styles.toppingSkin2DropdownOptions}`}>
              {topping?.values?.map(
              (value: ToppingValue, indexValue: number) =>
              <li
                className={`${styles.toppingSkin2DropdownOption} ${
                isActive(value, index) && styles.toppingSkin2ToppingActive
                }`}
                onClick={() =>
                addOrUpdate(
                  {
                    ...value,
                    toppingId: topping.id,
                    toppingName: topping.name
                  },
                  index
                )}

                key={`topping-value-${index}-${indexValue}`}>

                    {value.name}
                  </li>

            )}
            </ul>
          </label>
        </div>
      )}
    </div>);

};